import { render, staticRenderFns } from "./My_investment.vue?vue&type=template&id=2df776d6&scoped=true&"
import script from "./My_investment.vue?vue&type=script&lang=js&"
export * from "./My_investment.vue?vue&type=script&lang=js&"
import style0 from "./My_investment.vue?vue&type=style&index=0&id=2df776d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df776d6",
  null
  
)

export default component.exports